import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

import { UserContext } from '../../User/UserProvider.tsx';
import LoginRedirect from './LoginRedirect';

const PrivateRoute = ({ component, loggedIn, location, ...rest }) => {
  const user = useContext(UserContext);
  const auth = useAuth();

  // Ikke trigger login() mens auth initialiserer eller mens vi allerede
  // redirecter til innlogging (f.eks. etter auth.removeUser() i interceptoren).
  if (auth.isLoading || auth.activeNavigator) {
    return null;
  }

  if (
    user.isLoggedIn() &&
    (user.isEntreprenor() ||
      user.isKontrollor() ||
      user.isForvalter() ||
      user.isEnkAdmin())
  ) {
    return <Route {...rest} component={component} />;
  }
  if (user.isLoggedIn()) {
    // Innlogget, men uten rolle for denne ruten. login() her gir en evig runde
    // mot OneLogin (ny ?code= hver gang), siden OneLogin-sesjonen er gyldig og
    // svarer umiddelbart.
    if (user.isDashboard()) {
      return <Redirect to="/admin/monitor_map/monitor" />;
    }
    return <Redirect to="/unauth" />;
  }
  return <LoginRedirect vakt="PrivateRoute" />;
};
function mapStateToProps(state) {
  return {
    loggedIn: state.login != null,
  };
}

PrivateRoute.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  component: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func])
    .isRequired,
  location: PropTypes.shape({}),
};

PrivateRoute.defaultProps = {
  location: {},
};

export default connect(mapStateToProps)(PrivateRoute);
